import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from '../../../Hooks';

type Props = {
  onReady: () => void;
};

const OrderHistoryNotification = ({ onReady }: Props) => {
  const history = useHistory();
  const user = useSelector((state) => state.user);
  const [orderId, setOrderId] = useState<string | null>(null);

  useEffect(() => {
    onReady();
  }, []);

  const onMessage = (msg: any) => {
    let data = msg?.data;

    try {
      data = typeof data === 'string' ? JSON.parse(data) : data;
    } catch {
      return;
    }

    if (data?.orderId) {
      setOrderId(data.orderId);
    }
  };

  useEffect(() => {
    if (!orderId || !user) {
      return;
    }

    history.push(`/order-history/${orderId}`);
    setOrderId(null);
  }, [orderId, user]);

  useEffect(() => {
    // Add the event listener for messages passed from app wrapper
    document.addEventListener('message', onMessage);
    window.addEventListener('message', onMessage);

    // To prevent memory leaks, remove all event listeners on demount
    return () => {
      document.removeEventListener('message', onMessage);
      window.removeEventListener('message', onMessage);
    };
  }, []);

  return null;
};

export default OrderHistoryNotification;
